var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.41421L9 14.5858C9 15.4767 7.92286 15.9229 7.2929 15.2929L0.707107 8.70711C0.316583 8.31658 0.316582 7.68342 0.707106 7.29289L7.29289 0.707108C7.92286 0.0771427 9 0.523308 9 1.41421Z",
    fill: "#F59D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowPrimary);
export default __webpack_public_path__ + "static/media/LeftArrowPrimary.0b3e0d23b9f9f629aceba6346d82be58.svg";
export { ForwardRef as ReactComponent };